import { render } from "./addBuildingsSpecificData.vue?vue&type=template&id=a5d793c6&scoped=true"
import script from "./addBuildingsSpecificData.vue?vue&type=script&lang=js"
export * from "./addBuildingsSpecificData.vue?vue&type=script&lang=js"

import "./addBuildingsSpecificData.vue?vue&type=style&index=0&id=a5d793c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d793c6"]])

export default __exports__